import moment from "moment";
import { ListFieldsType, myDocumentsListName } from "src/api/config";
import { nameFromEmail, shortNameFromEmail } from "src/utils/users.utils";
import { MyDocumentsType } from "../../../../types/main";

export function modifiedMyDocumentsList(data: ListFieldsType[typeof myDocumentsListName][]): MyDocumentsType[] {
  let resultsObj: MyDocumentsType[] = [];

  if (data && data.length > 0) {
    for (const item of data) {
      const obj = {
        id: item.ID,
        code: {
          code: `${item.Code}.${item.Index}`,
          name: item.Title,
        },
        aboutDocument: {
          collection: item.Collection.Title,
          department: item.Department.Title,
          sector: item.Sector.Title,
          process: item.Process.Title,
          type: item.DocType.Title,
        },
        responsibleForRevision: {
          name: item.ResponsibleForRevision.Email
            ? `${nameFromEmail(item.ResponsibleForRevision.Email)}`
            : "Неизветный",
          avatar: null,
          email: item.ResponsibleForRevision.Email,
          shortName: shortNameFromEmail(item.ResponsibleForRevision.Email),
        },
        publicationDate: moment(item.PublicationDate).locale("ru").format("DD.MM.YYYY"),
        critical: item.Critical,
      };
      resultsObj.push(obj);
    }
  }

  return resultsObj;
}
